import { type CSSProperties, type ReactNode } from 'react';
import { TopBarStateContext } from '../../lib/TopBarStateContext';
import { useTopBarState } from '../../lib/useTopBarState';
import { type TopBarLayout } from '../../types';
import { useMeasuredTopBarHeight } from './useMeasuredTopBarHeight';
import styles from './TopBarLayoutWrapper.module.css';

const LAYOUT_CLASS: Record<TopBarLayout, string> = {
    ALERT_COMPACT: styles.alertCompact,
    ALERT_EXPANDED: styles.alertExpanded,
    ONLY_ONBOARDING: styles.onlyOnboarding,
    ONBOARDING_WITH_ADV: styles.onboardingWithAdv,
    AFTER_ONBOARDING_ADV: styles.afterOnboardingAdv,
    ONBOARDING_WITH_CONFIGURED: styles.onboardingWithConfigured,
    AFTER_ONBOARDING_CONFIGURED: styles.afterOnboardingConfigured,
    HIDDEN: styles.hidden,
};

export const TopBarLayoutWrapper = ({ children }: { children: ReactNode }) => {
    const state = useTopBarState();
    const { topBarRef, measuredHeight } = useMeasuredTopBarHeight(state.layout);
    // Высоту TopBar с конфигурируемой растяжкой измеряем; для остальных состояний она задана в CSS.
    const style =
        measuredHeight === undefined ? undefined : ({ '--top-bar-height': `${measuredHeight}px` } as CSSProperties);

    return (
        <TopBarStateContext.Provider value={{ ...state, topBarRef }}>
            <div className={LAYOUT_CLASS[state.layout]} style={style}>
                {children}
            </div>
        </TopBarStateContext.Provider>
    );
};
